import Vue from 'vue'
import Router from 'vue-router'
import { getAdminToken } from '@/libs/adminRequest'

Vue.use(Router)


// 公共路由
export const constantRoutes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
  },
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('@/views/mobile/wxLogin'),
  },
  {
    path: '/admin/login',
    name: 'adminLogin',
    component: () => import('@/views/admin/AdminLogin'),
  },
  {
    path: '/admin',
    component: () => import('@/views/admin/AdminLayout'),
    redirect: '/admin/overview',
    meta: { requiresAdmin: true },
    children: [
      {
        path: 'overview',
        name: 'adminOverview',
        component: () => import('@/views/admin/Overview'),
        meta: { requiresAdmin: true, title: '概览' },
      },
      {
        path: 'auth-logs',
        name: 'adminAuthLogs',
        component: () => import('@/views/admin/AuthLogs'),
        meta: { requiresAdmin: true, title: '授权登录记录' },
      },
      {
        path: 'push-logs',
        name: 'adminPushLogs',
        component: () => import('@/views/admin/PushLogs'),
        meta: { requiresAdmin: true, title: '消息推送记录' },
      },
      {
        path: 'apps',
        name: 'adminApps',
        component: () => import('@/views/admin/Apps'),
        meta: { requiresAdmin: true, title: '应用配置' },
      },
      {
        path: 'push-config',
        name: 'adminPushConfig',
        component: () => import('@/views/admin/PushConfig'),
        meta: { requiresAdmin: true, title: '推送配置' },
      },
      {
        path: 'security',
        name: 'adminSecurity',
        component: () => import('@/views/admin/SecuritySettings'),
        meta: { requiresAdmin: true, title: '安全设置' },
      },
      {
        path: 'password',
        name: 'adminPassword',
        component: () => import('@/views/admin/Password'),
        meta: { requiresAdmin: true, title: '修改密码' },
      },
    ],
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
  },
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

// 管理端登录守卫：只在本地没有令牌时拦截，令牌真伪由后端判定（后端返回 400 时请求层会踢回登录页）
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin) && !getAdminToken()) {
    next({ path: '/admin/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
